<template lang="pug">
  .root
    the-heading(:caption="caption" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption {{caption}}
          .fields
            .item_direcrory_edit(v-if="alias === 'sys-document-mapping'")
              label Код услуги по умолчанию
              .field_container
                WebiomedSearchField(
                  v-model="data.service"
                  :search_by="'id'"
                  :show="'code'",
                  :additional_name="'name'"
                  :address="'nsi/values/sys-services/'"
                  :fieldAdd="'?code__icontains='"
                  :placeholder="'Введите код услуги'",
                  :icons="'briefcase-medical'",
                  :defaultValue="data.service_text || ''",
                  :namespase="'DirectoryEdit'"
                )
            .item_direcrory_edit(v-if="alias === 'sys-laboratory-test-mapping'")
              label Название лабораторного теста
              .param {{data.parameter_name || 'Не указан'}}
              label Код ФСЛИ
              .param {{data.lab_test_text || 'Не указан'}}
              label Для справки - федеральный справочник лабораторных исследований «Справочник лабораторных тестов» можно открыть по ссылке
              .link
                a(:href="'https://nsi.rosminzdrav.ru/#!/refbook/1.2.643.5.1.13.13.11.1080 '" add target="_blank")
                  b https://nsi.rosminzdrav.ru/#!/refbook/1.2.643.5.1.13.13.11.1080
            .item_direcrory_edit(v-if="alias === 'sys-laboratory-study-type-mapping'")
              label Код ФСЛИ
              .field_container
                WebiomedSearchField(
                  v-model="data.lab_type"
                  :search_by="'id'"
                  :show="'name'",
                  :additional_name="'code'"
                  :address="'nsi/values/sys-laboratory-study-types/ultrafield/'"
                  :fieldAdd="'?param1__icontains='"
                  :placeholder="'Введите наименование или код'",
                  :icons="'briefcase-medical'",
                  :defaultValue="data.lab_type_text",
                  :namespase="'DirectoryEdit'"
                )
              label Для справки - федеральный справочник лабораторных исследований «Справочник лабораторных тестов» можно открыть по ссылке
              .link
                a(:href="'https://nsi.rosminzdrav.ru/#!/refbook/1.2.643.5.1.13.13.11.1080 '" add target="_blank")
                  b https://nsi.rosminzdrav.ru/#!/refbook/1.2.643.5.1.13.13.11.1080
            .item_direcrory_edit(v-if="alias === 'sys-service-mapping'")
              label Код МО
              .param {{data.mo_code || 'Не указан'}}
              label Код ОМС
              .param {{data.oms_code || 'Не указан'}}
              label Код услуги
              .field_container
                WebiomedSearchField(
                  v-model="data.service"
                  :search_by="'id'"
                  :show="'code'",
                  :additional_name="'name'"
                  :address="'nsi/values/sys-services/'"
                  :fieldAdd="'?code__icontains='"
                  :placeholder="'Введите код услуги'",
                  :icons="'briefcase-medical'",
                  :defaultValue="data.service_text || ''",
                  :namespase="'DirectoryEdit'"
                )
            .item_direcrory_edit(v-if="alias === 'sys-risk-group-descriptions'")
              .fields
                label(style="cursor: pointer") Активно
                  .field_container
                    input(type="checkbox" v-model="data.is_active")
                label Код *
                  .field_container
                    WebiomedInput(v-model="data.code" :error="errors.code")
                label Название *
                  .field_container
                    WebiomedInput(v-model="data.name" :error="errors.name")
                label Методология *
                  WebiomedSelect(:options="methodologyOptions" v-model="data.methodology" :defaultValue="data.methodology_text" :error="errors.methodology" style="margin-top: 7px; font-weight: normal")
                label Группа риска *
                  WebiomedSelect(:options="riskMethodsOptions" v-model="data.risk_group" :defaultValue="data.risk_group" :error="errors.risk_group" style="margin-top: 7px; font-weight: normal")
                label Описание по-русски
                  .field_container
                    textarea(style="width: 100%" v-model="data.description_ru")
                label Описание по-английски
                  .field_container
                    textarea(style="width: 100%" v-model="data.description_en")
            .item_direcrory_edit(v-if="alias === 'sys-doctor-recommendations' || alias === 'sys-patient-recommendations'")
              .fields
                label(style="cursor: pointer") Активно
                  .field_container
                    input(type="checkbox" v-model="data.is_active")
                label Код *
                  .field_container
                    WebiomedInput(v-model="data.code" :error="errors.code")
                label Название *
                  .field_container
                    WebiomedInput(v-model="data.name" :error="errors.name")
                label Нозология
                  WebiomedSelect(:options="nosologyOptions" v-model="data.nosology" :defaultValue="data.nosology"  style="margin-top: 7px; font-weight: normal")
                label Группа риска
                  WebiomedSelect(:options="riskMethodsOptions" v-model="data.risk_group" :defaultValue="data.risk_group" style="margin-top: 7px; font-weight: normal")
                    .field_container
                      WebiomedInput(v-model="data.risk_group" :error="errors.risk_group")
                label Описание по-русски
                  .field_container
                    textarea(style="width: 100%" v-model="data.recommendation_ru")
                label Описание по-английски
                  .field_container
                    textarea(style="width: 100%" v-model="data.recommendation_en")
    ButtonsPanel(v-if='perm' :save="true" :closeWithOutChanges="true" :remove="true")
    ButtonsPanel(v-if='!perm || alias === \'sys-laboratory-test-mapping\'' :close="true")
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import ButtonsPanel from '@/components/parts/ButtonsPanel'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import axios from 'axios'
import store from '../../../store'

export default {
  components: {
    TheHeading,
    ButtonsPanel,
    WebiomedInput,
    WebiomedSelect,
    WebiomedSearchField
  },
  data () {
    return {
      alias: null,
      breadcrumbs: [],
      prevCaption: null,
      caption: null,
      data: [],
      errors: {},
      methodologyOptions: [],
      riskMethodsOptions: [],
      nosologyOptions: [],
      perm: (store.state.user.user.is_staff && store.state.user.user.is_superuser)
    }
  },
  beforeCreate () {
    axios
      .get('dhra/api/v2/nsi/directories/' + this.$route.params.parentID + '/')
      .then(values => {
        this.alias = this.$route.params.alias
        this.prevCaption = values.data.short_name
        this.breadcrumbs = [
          {
            title: 'Администрирование',
            state: 'Administration'
          },
          {
            title: 'Справочники',
            state: 'NSI'
          },
          {
            title: this.prevCaption,
            state: 'DirectorySummary',
            params: { id: this.$route.params.parentID }
          }
        ]
        axios
          .get(
            `dhra/api/v2/nsi/values/${this.$route.params.alias}/${this.$route.params.id}/`
          )
          .then(values => {
            this.data = values.data
            document.title = values.data.name
            if (this.data.methodology) {
              axios
                .get('dhra/api/v2/nsi/values/sys-methodology/?limit=500&&is_active=true')
                .then(methodologies => {
                  for (let key in methodologies.data.results) {
                    if (
                      methodologies.data.results[key].id &&
                      methodologies.data.results[key].name
                    ) {
                      this.methodologyOptions.push({
                        id: methodologies.data.results[key].id,
                        name: methodologies.data.results[key].name
                      })
                    }
                  }
                })
            }
            if (this.data.risk_group) {
              axios
                .get('dhra/api/v2/nsi/values/sys-risk-groups/?limit=500&&is_active=true')
                .then(groups => {
                  for (let key in groups.data.results) {
                    if (
                      groups.data.results[key].id &&
                      groups.data.results[key].name
                    ) {
                      this.riskMethodsOptions.push({
                        id: groups.data.results[key].id,
                        name: groups.data.results[key].name
                      })
                    }
                  }
                })
            }
            if (this.data.nosology) {
              axios
                .get('dhra/api/v2/nsi/values/sys-nosologies/?limit=500&&is_active=true')
                .then(nosologies => {
                  for (let key in nosologies.data.results) {
                    if (
                      nosologies.data.results[key].id &&
                      nosologies.data.results[key].name
                    ) {
                      this.nosologyOptions.push({
                        id: nosologies.data.results[key].id,
                        name: nosologies.data.results[key].name
                      })
                    }
                  }
                })
            }
            this.caption = values.data.name
          })
          .catch(error => console.error(error.data))
      })
  },
  methods: {
    saveState () {
      axios
        .put(`dhra/api/v2/nsi/values/${this.alias}/${this.$route.params.id}/`, this.data)
        .then(
          response => {
            this.$notify({
              text: 'Справочник был успешно обновлен!',
              type: 'sucsess'
            })
            this.$router.go(-1)
          },
          errors => {
            this.errors = errors.response.data
            this.$notify({
              text: 'Поля заполнены некорректно',
              type: 'warn'
            })
          }
        )
    },
    closeState () {
      this.$router.go(-1)
    },
    removeState () {
      axios.delete(`dhra/api/v2/nsi/values/${this.alias}/${this.$route.params.id}/`).then(
        response => {
          this.$notify({
            text: 'Справочник был успешно удалён!',
            type: 'sucsess'
          })
          this.$router.go(-1)
        },
        errors => {
          this.$notify({
            text: 'Ошибка при удалении',
            type: 'warn'
          })
        }
      )
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DefaultStyles.sass"
.fields
  margin-top: 20px
  padding-right: 40px
  display: grid
  grid-template-columns: 1fr
  grid-column-gap: 40px
.item_direcrory_edit
  margin-bottom: 20px
.item_direcrory_edit label
  font-weight: normal
  font-size: 16px
.item_direcrory_edit .param
  margin-top: 5px
  font-weight: 450
  font-size: 18px
.item_direcrory_edit .link
  margin-top: 5px
  font-size: 18px

.link a
  font-weight: 450
  text-decoration: none

.link a:hover
  text-decoration: underline

.field_container
  margin-top: 7px
</style>
<style lang="sass">
.DirectoryEdit
  font-size: 15px
  height: 32px
</style>
